<a
  (click)="delete({ source: 'button' })"
  class="btn btn-default btn-xs"
  [class.disabled]="(selectedShapeCount$ | async) === 0"
  [matTooltip]="tooltip"
>
  <fa-icon [icon]="faTrash" [fixedWidth]="true"></fa-icon>
</a>
